import { io, Socket } from 'socket.io-client'

import type { SocketEmitList } from './socket-emit'
import type { SocketEventList } from './socket-event'

export type SocketClient = null | {
  io: Socket<SocketEventList, SocketEmitList>
  reset: () => void
}

let socket: null | Socket<SocketEventList> = null
// const visibilityInitialized = false
// const hiddenAt: null | number = null
// const AFK_LIMIT = 60_000 // 1 минута
// const AFK_LIMIT_RELOAD = 1_200_000 // 20 минут

export function createSocket(baseUrl: string, userStore: ReturnType<typeof useBrickUserStore>): SocketClient {
  if (import.meta.server) {
    return null
  }

  // -----------------------------
  //  CREATE ONLY ONCE – SINGLETON
  // -----------------------------
  if (!socket) {
    socket = io(baseUrl, {
      query: {
        auth: userStore.user?.auth_code || '',
      },
      transports: ['websocket'],
    })

    socket.on('connect', () => undefined)
    if (window) {
      window.SPIN_SOCKET_DOWN = socket.close
    }
  }

  // -----------------------------
  //  AFK / VISIBILITY LOGIC
  //  (runs ONCE globally)
  // -----------------------------
  // if (!visibilityInitialized && import.meta.client) {
  //   visibilityInitialized = true

  //   document.addEventListener('visibilitychange', () => {
  //     if (!socket) {
  //       return
  //     }

  //     // Вкладка скрылась → немедленно выключаем сокет
  //     if (document.hidden) {
  //       hiddenAt = Date.now()
  //       socket.disconnect() // ❗ сокет полностью выключен — не пингует
  //       return
  //     }

  //     // Вкладка снова видима → проверяем время AFK
  //     if (hiddenAt) {
  //       const diff = Date.now() - hiddenAt

  //       if (diff >= AFK_LIMIT) {
  //         // Был AFK мало → main_page
  //         const app = useNuxtApp()
  //         app.$di.root.init()
  //         return
  //       }
  //       if (diff >= AFK_LIMIT_RELOAD) {
  //         // Был AFK слишком долго → перезагрузка
  //         location.reload()
  //         return
  //       }
  //     }

  //     // AFK меньше минуты → просто переподключаем сокет
  //     socket.connect()
  //   })
  // }

  // -----------------------------
  //  RESET TOKEN / REAUTH
  // -----------------------------
  function reset(): void {
    if (!socket) {
      return
    }
    socket.io.opts.query = {
      auth: userStore.user?.auth_code?.replace('auth=', '') || '',
    }
    socket.disconnect().connect()
  }

  return { io: socket, reset }
}
